export function featureToFeatureCollection(obj) {
  if (!obj) return null;
  if (obj.type === 'FeatureCollection') return obj;
  if (obj.type === 'Feature') return { type: 'FeatureCollection', features: [obj] };
  if (obj.type === 'Polygon' || obj.type === 'MultiPolygon' || obj.type === 'Point') {
    return { type: 'FeatureCollection', features: [{ type: 'Feature', properties: {}, geometry: obj }] };
  }
  return null;
}

export function geojsonToWKT(featureOrGeom) {
  if (!featureOrGeom) return null;
  const geom = featureOrGeom.geometry ? featureOrGeom.geometry : featureOrGeom;
  if (!geom || !geom.type) return null;
  if (geom.type === 'Polygon') {
    const rings = geom.coordinates;
    const coords = rings[0].map((c) => `${c[0]} ${c[1]}`).join(',');
    return `POLYGON((${coords}))`;
  }

  if (geom.type === 'MultiPolygon') {
    const polys = geom.coordinates
      .map((poly) => {
        const ring = poly[0].map((c) => `${c[0]} ${c[1]}`).join(',');
        return `((${ring}))`;
      })
      .join(',');
    return `MULTIPOLYGON(${polys})`;
  }
  if (geom.type === 'Point') {
    return `POINT(${geom.coordinates[0]} ${geom.coordinates[1]})`;
  }
  return JSON.stringify(geom);
}

export function polygonCoordsStringFromGeoJSON(featureOrGeom) {
  if (!featureOrGeom) return null;
  const geom = featureOrGeom.geometry ? featureOrGeom.geometry : featureOrGeom;
  if (!geom || !geom.type) return null;

  if (geom.type === 'Polygon') {
    const ring = geom.coordinates[0];
    return ring.map((c) => `${c[0]} ${c[1]}`).join(',');
  }

  if (geom.type === 'MultiPolygon') {
    const ring = geom.coordinates[0][0];
    return ring.map((c) => `${c[0]} ${c[1]}`).join(',');
  }

  if (geom.type === 'Point') {
    return `${geom.coordinates[0]} ${geom.coordinates[1]}`;
  }

  return null;
}

export function computeCentroidFromGeoJSON(featureOrGeom) {
  if (!featureOrGeom) return { lat: null, lon: null };
  const geom = featureOrGeom.geometry ? featureOrGeom.geometry : featureOrGeom;
  if (!geom || !geom.type) return { lat: null, lon: null };

  if (geom.type === 'Polygon') {
    const ring = geom.coordinates[0];
    let area = 0;
    let cx = 0;
    let cy = 0;
    for (let i = 0, len = ring.length - 1; i < len; i++) {
      const [x0, y0] = ring[i];
      const [x1, y1] = ring[i + 1];
      const a = x0 * y1 - x1 * y0;
      area += a;
      cx += (x0 + x1) * a;
      cy += (y0 + y1) * a;
    }
    area = area / 2;
    if (area === 0) {
      const avg = ring.reduce(
        (acc, c) => {
          acc[0] += c[0];
          acc[1] += c[1];
          return acc;
        },
        [0, 0]
      );
      const n = ring.length;
      return { lon: avg[0] / n, lat: avg[1] / n };
    }
    cx = cx / (6 * area);
    cy = cy / (6 * area);
    return { lon: cx, lat: cy };
  }

  if (geom.type === 'Point') {
    return { lon: geom.coordinates[0], lat: geom.coordinates[1] };
  }

  if (geom.type === 'MultiPolygon') {
    const ring = geom.coordinates[0][0];
    const fc = { type: 'Polygon', coordinates: [ring] };
    return computeCentroidFromGeoJSON(fc);
  }

  return { lat: null, lon: null };
}

export function wktToGeoJSON(wkt) {
  if (!wkt || typeof wkt !== 'string') return null;
  const cleanWkt = wkt.trim().toUpperCase();

  try {
    if (cleanWkt.startsWith('POLYGON')) {
      const match = cleanWkt.match(/\(\(([^)]+)\)\)/);
      if (!match || !match[1]) return null;

      const coordString = match[1];
      const points = coordString.split(',').map((pointStr) => {
        const [lngStr, latStr] = pointStr.trim().split(/\s+/);
        return [parseFloat(lngStr), parseFloat(latStr)];
      });

      return {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Polygon',
          coordinates: [points]
        }
      };
    }

    if (cleanWkt.startsWith('POINT')) {
      const match = cleanWkt.match(/\(([^)]+)\)/);
      if (!match || !match[1]) return null;

      const [lngStr, latStr] = match[1].trim().split(/\s+/);
      return {
        type: 'Feature',
        properties: {},
        geometry: {
          type: 'Point',
          coordinates: [parseFloat(lngStr), parseFloat(latStr)]
        }
      };
    }
  } catch (error) {
    console.error('Gagal mem-parsing WKT ke GeoJSON:', error);
    return null;
  }

  return null;
}
